﻿export class SignalrGroup {
  public constructor(public baseRoleId: number, public groupName: string) {}
}
